import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEnergy_imports_importIdRevert = z.any()
export type TagsPostEnergy_imports_importIdRevert = z.infer<typeof tagsPostEnergy_imports_importIdRevert>

export const paramsPostEnergy_imports_importIdRevert = z.object({ "importId": z.string() })
export type ParamsPostEnergy_imports_importIdRevert = z.infer<typeof paramsPostEnergy_imports_importIdRevert>

export const responsePostEnergy_imports_importIdRevert = z.object({ "payload": z.object({ "id": z.string(), "status": z.literal("reverted") }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEnergy_imports_importIdRevert = z.infer<typeof responsePostEnergy_imports_importIdRevert>

interface IPostEnergy_imports_importIdRevert extends BaseMethodType {
  tags: TagsPostEnergy_imports_importIdRevert,
  params: ParamsPostEnergy_imports_importIdRevert,
  response: ResponsePostEnergy_imports_importIdRevert
}
export const URL = '/energy-imports/:importId/revert'
export const validation = {
  post: {
    tags: tagsPostEnergy_imports_importIdRevert,
    params: paramsPostEnergy_imports_importIdRevert,
    response: responsePostEnergy_imports_importIdRevert
  }
}
export interface Energy_imports_importIdRevert extends BaseRouteType {
  post: IPostEnergy_imports_importIdRevert
}